import { theme } from 'root/theme';


export function isMobileScreen() {
	//check for portrait? window.matchMedia("(orientation: portrait)")
	return window.matchMedia(theme.mediaQuery.mobile).matches;	
}